<template>
    <div class="deal_index_box">
        <!-- 帳單管理 -->
        <div class="deal_title">
            <div>帳單管理<span>》</span>資金帳單</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box" v-loading="inquireTF">
            <div class="deal_content_title">資金帳單</div>
            <div class="deal_content">
                <div class="center_box">
                    <!-- 資金帳單 -->
                    <el-form ref="form" :model="form" label-width="90px">
                        <el-form-item label="帳號類型：">
                            <el-radio-group v-model="typeRadio">
                                <el-radio-button label="基本帳戶"></el-radio-button>
                                <!-- <el-radio-button label="手續費帳戶"></el-radio-button>
                                <el-radio-button label="退款帳戶"></el-radio-button>
                                <el-radio-button label="支出帳戶"></el-radio-button> -->
                            </el-radio-group>
                            <div class="hint_box">
                                <i class="el-icon-question"></i>
                                <div class="hint_text">手續費帳戶、退款帳戶、支出帳戶需申請後獨立分離</div>
                                <div class="hint_triangle"></div>
                            </div>
                        </el-form-item>
                        <el-form-item label="申請時間：">
                            <el-date-picker
                                v-model="dateValue"
                                type="daterange"
                                align="center"
                                value-format="timestamp"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                            <span class="deal_content_span">查詢期日不可超過31天</span>
                        </el-form-item>
                        <el-form-item label="進出類別：">
                            <el-select v-model="paymentValue" placeholder="所有進出類別">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="UID查詢：" v-show="this.$store.state.uid == '1' ">
                            <el-input class="uid_class" placeholder="" v-model="uidVal" clearable></el-input>
                        </el-form-item>
                    </el-form>
                    <!-- 查詢按钮 -->
                    <div class="inquire_button">
                    <el-button type="primary"  @click="inquireFun()">查詢</el-button>   
                    </div>
                    <!-- 表单 -->
                    <div class="table_download">
                        <span>匯出記錄</span>
                        <span class="exe_div"><img src="../../../../assets/img/login/logindeal/icon_xls.png" @click="ExcelFun('exportexcel')" alt=""></span>
                        <!-- <span><img src="../../../../assets/img/login/logindeal/icon_txt.png" @click="ExcelFun('exporttxt')" alt=""></span> -->
                    </div>
                    <div>
                         <!-- 表单头 -->
                            <div class="table_header">
                                <div class="table_uid">UID</div>
                                <div class="table_date">日期</div>
                                <div class="table_over">期初餘額</div>
                                <div class="table_money">進出類別</div>
                                <div class="table_money">入帳金額</div>
                                <div class="table_number">入帳筆數</div>
                                <div class="table_money">提領/支付</div>
                                <div class="table_number">提領/支付筆數</div>
                                <div class="table_money">帳戶結餘</div>
                                <div class="table_operation">下載帳單</div>
                            </div>
                            <!-- 表单内容 -->
                            <div class="table_maxbox" v-for="(list, index) of pagelist" :key="index" v-show="currentPage == (index+1)">
                                <div class="table_content" v-for="item of list" :key="item.id">
                                    <div class="table_uid">{{item.uid}}</div>
                                    <div class="table_date">{{item.time}}</div>
                                    <div class="table_over">{{item.over}}</div>
                                    <div class="table_money">{{item.type}}</div>
                                    <div class="table_money">{{item.sr}}</div>
                                    <div class="table_number">{{item.sr_b}}</div>
                                    <div class="table_money">{{item.zc}}</div>
                                    <div class="table_number">{{item.zc_b}}</div>
                                    <div class="table_money">{{item.unover}}</div>                              
                                    <div class="table_operation">
                                        <!-- @click="funEmit(item.time, item.uid)" -->
                                        <span @click="funEmit(item.time, item.uid, item.type)">
                                            <span class="blue_text">業務明細</span>
                                        </span>
                                        <!-- <span>
                                            <span class="blue_text">業務匯總</span>
                                        </span> -->
                                    </div>
                                </div>
                            </div>
                        <!-- 表单分页列表 -->
                        <div class="table_pagination">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 30, 50]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalNumber"
                                >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- deal_index_box -->
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'LoginDealMoneyBills',
    data() {
        return {
            form:{
            },
            typeRadio:'基本帳戶',
            inquireTF: false,
            // 日期
            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            uidVal: '',
            dateValue: '',
            start_time: '',
            end_time: '',
            paymentValue: '',
            transactionValue: '',
            // 表单
            tableData: [],
            totalNumber: 0,
            currentPage: 1,
            pageSize: 10,
            pagelist:[],
            options: [{
                value: '',
                label: '全部'
            }, {
                value: '1',
                label: '撥款'
            }, {
                value: '2',
                label: '單次提領'
            }],
            paymentValue: '',
        // return
        }
    },
    methods: {
        handleClick(tab, event) {
            // console.log(tab, event);
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.pagelist = this.pagesFun(val);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
        },
        funEmit(time, uid, type){
            let stringTime = time + " 00:00:00";
            stringTime = new Date(stringTime).getTime();
            let string = stringTime - 3600 * 1000 * 24;
            // let lastTime = stringTime.setTime(stringTime.getTime() - 3600 * 1000 * 24);
            let arr = [];
      
          
            let trueTF = {};
            trueTF.trueTF = '1';
            trueTF.uid = uid;
            if(type == '撥款'){
                 // 开始日期跟结束日期按查询修改成同一天 按提领时间 前一天
                trueTF.type = '1';
                arr[0] = string;
                arr[1] = string;
            } else {
                 // 开始日期跟结束日期按查询修改成同一天 按交易时间
                trueTF.type = '2';
                 arr[0] = stringTime;
                arr[1] = stringTime;

            }
            // console.log(arr);
            this.$store.commit('changeDateVal',arr);
            this.$store.commit('changeDateValTF',trueTF);
            this.$router.push("/login/deal/statement");
            this.$emit('moneybillsFun');
        },
        // FUN-分頁顯示
        pagesFun(number){
            let pages=[];
            this.tableData.forEach((item,index)=>{
                var page=Math.floor(index/number);
                if(!pages[page]){
                    pages[page]=[];
                }
                pages[page].push(item);
            })
            return pages;
        },
        // FUN-订单查询
        inquireFun(){

            // 交易时间：
            if( this.dateValue ){
                this.end_time = this.dateValue[1].toString();
                this.end_time = this.end_time.substring(0, 10);
                this.start_time = this.dateValue[0].toString();
                this.start_time = this.start_time.substring(0, 10);
            } else {
                this.dateValue = '';
                this.end_time = '';
                this.start_time = '';
            }

            this.inquireTF = true;
            axios.get(this.$store.state.axiosMoneyBillsUrl, {
                params: {
                    start_time: this.start_time,
                    end_time: this.end_time,
                    uid: this.uidVal,
                    type: this.paymentValue,
                }
            }).then((res) => {
                // console.log(res.data);
                this.inquireTF = false;
                this.currentPage = 1;
                 if(res.data.message){
                    if(res.data.status){
                        this.tableData = res.data.message;
                        // console.log(this.tableData);
                        this.totalNumber = res.data.message.length;
                        this.pagelist = this.pagesFun(this.pageSize);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error',
                            duration: 1000
                        });
                    }
                 } else {
                    this.$message({
                        showClose: true,
                        message: '沒有數據',
                        type: 'error',
                        duration: 1000
                    });
                    this.tableData = [];
                    this.pagelist = this.pagesFun(this.pageSize);
                    this.totalNumber = 0;
                }
            })
        },
        // FUN-EXCEL下載
        ExcelFun(hxr){
            let txt_url = '';
            let charset = '';
            let uidvalue = '';
            // 简体还是繁体
            if (navigator.language === "zh-TW"){
                charset = "BIG5";
            } else {
                charset = "GBK";
            }
            // 是否UID
            if (this.uidVal == ''){
               uidvalue = this.$store.state.uid;
            } else {
               uidvalue = this.uidVal;
            }
            // 下载：
            txt_url = this.$store.state.axiosMoneyBillsUrl
                +'&uid='+uidvalue
                +'&end_time='+this.end_time
                +'&start_time='+this.start_time
                +'&type='+this.paymentValue
                +'&charset='+charset
                +'&do='+hxr;

            window.location.href = txt_url;
        },
    },
    created() {
        this.uidVal = this.$store.state.uid;
        this.inquireTF = true;
        // 時間：
        let start = new Date(new Date(new Date().toLocaleDateString()).getTime());
        start.setTime(start.getTime() - 3600 * 1000 * 24);
        start = start.getTime();
        let end = new Date(new Date(new Date().toLocaleDateString()).getTime());
        end = end.getTime();
        let list = [];
        list[0] = start;
        list[1] = end;
        this.dateValue = list;
        this.inquireFun();
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .hint_box {
        font-size: 15px;
        display: inline-block;
        color: #26b5d2;
        margin-left: 8px;
        position: relative;
    }
    .hint_box:hover .hint_text {
        display: block;
    }
    .hint_box .hint_text {
        display: none;
        box-sizing: border-box;
        position: absolute;
        bottom: -12px;
        left: 6px;
        border: 1px solid #26b5d2;
        line-height: 19px;
        font-size: 11px;
        color: #777;
        width: 286px;
        padding: 0 4px;
    }
    /* .hint_box .hint_triangle {
        border: 1px solid #26b5d2;
        position: absolute;
        width: 10px;
        height: 10px;
    } */
    .time_box {
        font-size: 17px;
        margin-bottom: 33px;
        letter-spacing: 1px;
    }
    .time_box > span {
        color: #e73262;
        margin: 0 5px;
    }
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 500px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 38px 20px;
        padding-top: 26px;
    }
    .center_box {
        min-width: 960px;
        margin: 10px 65px;
    }
    .deal_content_span {
        margin-left: 23px;
        font-size: 11px;
        color: #e73262;
    }
    .deal_content_tab_first {
        width: 960px;
    }
    .deal_content_tab_first > div {
        margin: 14px 0;
    }
    .money_box span {
        margin: 0 10px;
    }
    .money_input {
        width: 140px;
        /* margin-left: 4px; */
    }
    .money_input01 {
        margin-left: 4px;
    }
    .uid_class {
        width: 350px;
    }
    .inquire_button {
        padding: 10px;
    }
    /* 表单 */
    .table_download {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 6px 0;
        margin-bottom: 6px;
    }
    .table_download span {
        display: inline-block;
        margin: 0 10px;
    }
    .exe_div {
        cursor: pointer;
    }
    .blue_text {
        color: #326ede;
        padding-bottom: 4px;
        border-bottom: 1px solid;
    }
    /* 表单头 */
    .table_header {
        height: 36px;
        line-height: 36px;
        background: #f2f2f2;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        text-align: center;
    }
    .table_maxbox >div+div {
        border-top: 1px solid #e7e7e7;
    }
    .table_content {
        padding: 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        text-align: center;
    }
     .table_date {
        box-sizing: border-box;
        width: 10%;
        padding-left: 14px;
        padding-right: 10px;
    }
     .table_uid {
        box-sizing: border-box;
        width: 6%;
        padding-left: 14px;
        padding-right: 10px;
    }
    .table_over {
        box-sizing: border-box;
        width: 8%;
        padding-left: 14px;
        padding-right: 10px;
    }
    .table_money {
        box-sizing: border-box;
        width: 10%;
        padding: 0 10px;
    }
    .table_number {
        box-sizing: border-box;
        width: 11%;
        padding: 0 10px;
    }
    .table_operation {
        padding: 0 10px;
    }
    .table_operation > span {
        margin-right: 10px;
        cursor: pointer;
    }
    .table_operation > span > span {
        margin-right: 2px;
        padding-bottom: 2px;
        border-bottom: 1px solid;
    }
/* 分页 */
    .table_pagination {
        display: flex;
        margin: 20px;
        justify-content: flex-end;
    }
    .annotation {
        font-size: 11px;
        color: #777;
    }
    .annotation > p {
        line-height: 17px;
        margin-left: 18px;
    }
    .annotation .annotation_p {
        margin: 0px;
        margin-top: 10px;
    }
    .annotation .annotation_span {
        border-bottom: 1px solid #326ede;
        color: #326ede;
    }
</style>
